import { css } from 'lit';
export const phoneStyles = css ``;
//# sourceMappingURL=phone.styles.js.map